import { ArrowDownSVG } from "src/assets/svg";
import Budi from "src/assets/img/budi.png";

const CardProfile = () => {
  return (
    <div className="bg-slate-100 overflow-hidden">
      <div className="flex justify-center items-center">
        <img
          className="w-10 h-10 top-0 rounded-full border-2 border-light-blue object-cover"
          src={Budi}
          alt="Avatar Profile"
        />
        <div className="ml-2 font-bold">
          <h6 className="text-light-black text-xl font-weight-700">Budi Budiman</h6>
          <div className="text-light-gray text-base font-weight-700">Owner at PT Suka Maju</div>
        </div>
        <div>
          <ArrowDownSVG />
        </div>
      </div>
    </div>
  );
};

export default CardProfile;
